import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { noop } from 'lodash';

import FieldLabel from '../FieldLabel';
import styles from './MultilineTextField.scss';

// @todo move to or reuse from next-ui @feshchenko
class MultilineTextField extends React.Component {
  static propTypes = {
    disabled: PropTypes.bool,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    inputClassName: PropTypes.string,
    labelClassName: PropTypes.string,
    disabledLabelClassName: PropTypes.string,
    isError: PropTypes.bool,
    tip: PropTypes.string,
    labelAlign: PropTypes.string,
    readOnly: PropTypes.bool,
    label: PropTypes.node,
    className: PropTypes.string,
  };

  static defaultProps = {
    onFocus: noop,
    onBlur: noop,
  };

  state = {
    focused: false,
  };

  handleInputFocus = event => {
    if (this.props.disabled) return;
    this.setState({ focused: true });
    this.props.onFocus(event);
  };

  handleInputBlur = event => {
    this.setState({ focused: false });
    this.props.onBlur(event);
  };

  render = () => {
    const {
      className,
      labelClassName,
      disabledLabelClassName,
      inputClassName,
      label,
      isError,
      tip,
      labelAlign,
      disabled,
      remaining, // eslint-disable-line
      maximumCharacters, // eslint-disable-line
      tipClassName, // eslint-disable-line
      ...props
    } = this.props;
    const { focused } = this.state;

    return (
      <div
        className={cx(className, styles.container, {
          [styles.containerError]: isError,
          [styles.containerActive]: this.state.focused,
        })}
      >
        <FieldLabel
          text={label}
          isError={isError}
          isActive={focused}
          disabled={disabled}
          labelAlign={labelAlign}
          className={cx(styles.labelText, labelClassName)}
          labelClassName={styles.label}
          disabledClassName={disabledLabelClassName}
        >
          <textarea
            {...props}
            data-e2e="multiline-text-field"
            data-testid="SurveysSpa-MultilineTextField-TextField"
            disabled={disabled}
            className={cx(
              disabled ? styles.disabledInput : styles.input,
              inputClassName,
            )}
            onFocus={this.handleInputFocus}
            onBlur={this.handleInputBlur}
          />
          {tip && <span className={styles.tip}>{tip}</span>}
        </FieldLabel>
      </div>
    );
  };
}

export default MultilineTextField;
